module.exports = __webpack_public_path__ + "static/iphone-firstapp-792ed7ac913ae8d25ac122d67d441b76.svg";